import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService, IPrincipal } from '../authorization/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class EulaGuard {
  private _isAcceptedLicenseAgreement?: boolean;

  constructor(
    private _authorizationService: AuthorizationService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise((res) => {
      this._authorizationService.principal$.subscribe((user: IPrincipal) => {
        this._isAcceptedLicenseAgreement = user.permissions?.acceptedLicenseAgreement;
        if (user.identity.isAuthenticated && !this._isAcceptedLicenseAgreement) {
          this.router.navigate(['/license-agreement'], {
            queryParams: { currentRoute: state.url },
          });
          res(false);
        } else {
          res(true);
        }
      });
    });
  }
}
